module.exports = __webpack_public_path__ + "static/media/3.8e425f4a.jpg";